import React from 'react';
import PropTypes from '../../types';
import { PageHeading } from 'web-ui-components/lib/typography/headings';
import { StandardBody } from 'web-ui-components/lib/typography/body';
import { Form } from 'react-final-form';
import { Content } from '../../infrastructure/content';
import Control from './components/Control';
import ControllingPercentage from './components/ControllingPercentage';
import Submit from '../../components/Submit';
import { ButtonComponent } from '../../components/ButtonComponent';

const SignatoriesAndShareholdersPage = ({
  saveSignatoriesAndShareholdersForm,
  getBusinessData,
  showSubmit
}) => {
  return (
    <Form
      onSubmit={saveSignatoriesAndShareholdersForm}
      initialValues={getBusinessData}
      render={({ handleSubmit, values }) => (
        <form onSubmit={handleSubmit}>
          <Content>
            {({ signatoriesAndShareholdersPageTitle = '', signatoriesAndShareholdersContentA }) => (
              <div>
                <PageHeading>{signatoriesAndShareholdersPageTitle}</PageHeading>
                <StandardBody>
                  <p>{signatoriesAndShareholdersContentA}</p>
                </StandardBody>
                <Control values={values} />
                {values.control === 'Y' && <ControllingPercentage values={values} />}

                {showSubmit ? (
                  <Submit />
                ) : (
                  <ButtonComponent
                    title="Submit"
                    onClick={() => {
                      handleSubmit(values);
                    }}
                  ></ButtonComponent>
                )}
              </div>
            )}
          </Content>
        </form>
      )}
    />
  );
};
SignatoriesAndShareholdersPage.propTypes = {
  saveSignatoriesAndShareholdersForm: PropTypes.func.isRequired,
  showSubmit: PropTypes.bool.isRequired
};

export default SignatoriesAndShareholdersPage;
